const PRIVATE = ["/cerca", "/per-te", "/il-mio-segno", "/login", "/registrati", "/profilo", "/coupon", "/premi", "/livelli", "/quiz", "/storico-punti", "/riscatti", "/regole", "/missioni", "/admin", "/auth", "/password-dimenticata", "/reimposta-password"];
export const PUBLIC_ROBOTS = "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";
export const PRIVATE_ROBOTS = "noindex, nofollow";

export const isPrivatePath = (path = "/") => PRIVATE.some((p) => path === p || path.startsWith(`${p}/`));
export const robotsFor = (path) => (isPrivatePath(path) ? PRIVATE_ROBOTS : PUBLIC_ROBOTS);

export function applyRobots(path) {
  let el = document.head.querySelector('meta[name="robots"]');
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", "robots");
    document.head.appendChild(el);
  }
  el.setAttribute("content", robotsFor(path));
}
